import { createFileRoute } from '@tanstack/react-router';

import { ReviewPage } from '@/features/documents/review-page';

export const Route = createFileRoute('/_app/projects/$projectId/cost/scans/$extractionId')({
  component: ReviewRoute,
});

function ReviewRoute() {
  const { projectId, extractionId } = Route.useParams();
  return <ReviewPage projectId={projectId} extractionId={extractionId} />;
}
